import React, { useMemo, useState } from 'react';
import {
    TileBannerMenuContext,
    type TileBannerMenuAction,
} from '@rocco/contexts/TileBannerMenuContext';
import { AdminContextMenu } from './AdminContextMenu';
import type { TileViewModel, TileableModel } from '../view-models/tile';
import { TileKPISummary } from './TileKPISummary';

interface AdminTileProps {
    children: React.ReactNode;
    tile: TileViewModel<TileableModel>;
    actions?: {
        onEdit?: () => void;
        onRepositionImage?: () => void;
        onDelete?: () => void;
        onTogglePin?: () => void;
        onToggleFeature?: () => void;
        onToggleHeroPin?: () => void;
        onToggleFeaturedBrandPin?: () => void;
        onRemoveFromLibrary?: () => void;
    };
}

export const AdminTile: React.FC<AdminTileProps> = ({
    children,
    tile,
    actions,
}) => {
    const { adminStatusInfo } = tile;
    // The tile inside registers its set-as-banner action here (it targets the
    // tile's visible carousel slide, which only the tile can see).
    const [bannerAction, setBannerAction] =
        useState<TileBannerMenuAction | null>(null);
    const bannerRegistry = useMemo(() => ({ register: setBannerAction }), []);

    return (
        <TileBannerMenuContext.Provider value={bannerRegistry}>
            <AdminContextMenu
                {...actions}
                bannerAction={bannerAction ?? undefined}
                statusInfo={adminStatusInfo ?? undefined}
            >
                {children}
                {adminStatusInfo?.kpi && (
                    <TileKPISummary kpi={adminStatusInfo.kpi} />
                )}
            </AdminContextMenu>
        </TileBannerMenuContext.Provider>
    );
};
